import { useCallback, useState } from 'react';
import { useLocation, useHistory } from 'quartz-routing/react-router';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { PreviousIcon } from 'foundations-assets/icons/components/PreviousIcon';
import { Flex } from 'foundations-components/components/Flex';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Link } from 'foundations-components/transitional/components/Link';
import { useTheme } from 'foundations-theming/utils';
import { closeAppFromNative } from '../../utils/native/closeAppFromNative';
import { sendNativeAction } from '../../utils/native/sendNativeAction';
import { isHubspotAndroid, isHubSpotNativeApp } from '../../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const NativeBackButton = () => {
  const {
    pathname,
    state: {
      backLocation
    } = {}
  } = useLocation();
  const {
    replace
  } = useHistory();
  const [backLink, setBackLink] = useState('');
  const theme = useTheme();
  if (!backLink && backLocation) setBackLink(backLocation);
  const handleClose = useCallback(() => {
    if (/^\/lessons\/[0-9]+/.test(pathname) || /^\/tracks\/[0-9]+/.test(pathname)) {
      replace(backLink || '/');
    } else {
      sendNativeAction(closeAppFromNative());
    }
  }, [pathname, replace, backLink]);
  if (!isHubSpotNativeApp) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    backgroundColor: "fill-surface-default",
    blockSize: theme.space['1200'],
    "data-test-id": "mobile-close-button",
    insetBlockStart: "0",
    paddingBlock: "0",
    paddingInlineEnd: isHubspotAndroid ? '200' : '400',
    paddingInlineStart: "400",
    position: "sticky",
    zIndex: 3,
    children: isHubspotAndroid ? /*#__PURE__*/_jsx(IconButton, {
      onClick: handleClose,
      use: "link",
      children: /*#__PURE__*/_jsx(PreviousIcon, {
        size: "600"
      })
    }) : /*#__PURE__*/_jsx(BackButton, {
      display: "inline-flex",
      children: /*#__PURE__*/_jsx(Link, {
        onClick: handleClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.heading.closeWebviewButton"
        })
      })
    })
  });
};
export default NativeBackButton;